<!--
  +---------------------------------------------------------------------------------------
  | @Author:    xander<luoxingzhang@frippler.com>
  | @Title:     设备增值-收费方案
  +---------------------------------------------------------------------------------------
-->
<template>
  <div class="ei-scheme">
    <div class="filter-container">
      <div class="filter-box">
        <div class="filter-item sm" style="width:160px">
          <el-input v-model="query.keyword" placeholder="名称" prefix-icon="el-icon-search" clearable @change="fetchData()" />
        </div>
      </div>
      <div class="toolbox">
        <el-button icon="el-icon-plus" type="success" @click="toNewScheme">新方案</el-button>
        <f-sort-selector v-model="query.sort" :options="sortOptions" class="ml-sm" @change="fetchData(1)" />
      </div>
    </div>

    <el-card v-loading="loading" shadow="never">
      <el-table ref="schemeTable" :data="schemes" tooltip-effect="dark" class="padding-large">
        <el-table-column type="index" label="#" width="50"  />
        <el-table-column min-width="260" label="方案名称">
          <template slot-scope="scope">
            <div class="el-card-content" role="button" style="width:260px;height: 160px;"
              @click="toDetail(scope.row)">
              <div ref="col"
                :style="{ height: '100%', backgroundImage: `url(${require('../../assets/card-ap-year.jpg' )})` }"
                class="charge_card text-black mb-lg">
                <div class="flex column card_container">
                  <div>
                    <div class="flex">
                      <div v-overflow-tooltip class="bd text-bold ellipsis" style="font-size: 16px;height: 26px;line-height: 26px;">{{ scope.row.title }}</div>
                      <div class="ft">
                        <div
                          v-if="scope.row.activity_enable && scope.row.activity_params.title"
                          class="activity text-white" :class="[!scope.row.in_activity ? 'activity_off' : '' , time < scope.row.activity_params.starttime && 'unbegin']">{{ scope.row.activity_params.title }}</div>
                      </div>
                    </div>
                    <div class="flex mt-xs">
                      <template v-if="scope.row.is_default_platform_schemeid === 1">
                        <span role="button" class="default_item first_item flex-center">平台默认方案</span>
                      </template>
                      <template v-else>
                        <el-tooltip v-if="service === scope.row.schemeid" effect="dark" content="点击取消" placement="top">
                          <span role="button" class="default_item first_item flex-center" @click.stop="chooseService(scope.row.schemeid)">默认方案</span>
                        </el-tooltip>
                        <span
                          v-if="service !== scope.row.schemeid"
                          role="button"
                          class="default_item third_item flex-center"
                          @click.stop="chooseService(scope.row.schemeid)"
                        >
                          {{ servicechoose }}
                        </span>
                      </template>
                    </div>
                  </div>
                  <div v-if="scope.row.schemeid == 1" class="lock">
                    <i class="el-icon-lock"></i>
                  </div>
                  <div
                    v-if="scope.row.activity_enable && scope.row.activity_params.title && scope.row.in_activity"
                    class="flex container_foot text-bold">
                    <div class="flex container_foot">
                      <span>{{ scope.row.activity_params.discount_price | currency }}</span>
                      <span>/年</span>
                    </div>
                  </div>
                  <div v-else class="flex container_foot text-bold">
                    <span>{{ scope.row.price | currency }}</span>
                    <span>/年</span>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </el-table-column>

        <el-table-column min-width="300">
          <template slot="header" slot-scope="scope">
            <div class="flex align-items-center">
              <span class="mr-xs">收费标准</span>
              <el-tooltip placement="top" popper-class="price_tooltip">
                <span slot="content">
                  请注意，该收费标准将作为定价参考，实际售价还受商户促销、平台营销，
                  以及是否涉及物联卡保号复机等因素影响。最终收费标准，以下单时页面展示为准。
                </span>
                <i class="iconfont icon-circle-question" style="font-size: 14px;color: #999;"></i>
              </el-tooltip>
            </div>
          </template>
          <div slot-scope="scope">
            <div class="flex mb-sm" style="gap: 15px;">
              <div v-for="(item,index) in scope.row.packages" :key="index" class="scheme_item" :class="(!scope.row.activity_enable || !scope.row.in_activity) && 'flex-center'">
                <div v-if="scope.row.in_activity" class="flex column justify-content-center align-items-center text-black">
                  <div class="mt-sm text-bold">{{ item.num + unitOptions[item.unit] }}</div>
                  <div class="text-bold">￥{{ item.total_selling_price }}</div>
                  <div v-if="item.total_selling_price != item.total_market_price" class="text-muted line-through pb" style="font-size: 11px;height: 17px;line-height: 17px">￥{{ item.total_market_price }}</div>
                  <div v-else style="height: 17px" class="pb"></div>
                </div>
                <div v-else class="flex column justify-content-center align-items-center text-black">
                  <div class="mt-sm text-bold">{{ item.num + unitOptions[item.unit] }}</div>
                  <div class="text-bold">￥{{ item.total_market_price }}</div>
                  <div style="height: 17px" class="pb"></div>
                </div>
                <div v-if="scope.row.activity_enable && scope.row.in_activity" class="discount flex-center">
                  <div v-if="item.total_discount_price" class="save ellipsis" style="font-size: 12px;">
                    已优惠<span>￥{{ item.total_discount_price }}</span>
                  </div>
                  <div v-else class="save ellipsis">
                    无优惠
                  </div>
                </div>
              </div>
            </div>
            <div class="flex" style="gap: 15px;">
              <div v-for="(packageItem,index2) in scope.row.packages" :key="index2" class="expected_item">
                <div style="height: 17px;line-height: 17px;font-size: 12px;">{{ packageItem.num }}年收益预估</div>
                <div style="color: #997BEC;height: 20px;line-height: 20px" class="text-bold">{{ packageItem.income_price | currency }}</div>
              </div>
            </div>
            <el-alert v-if="scope.row.show_tip" type="warning" title="当前方案单价过高，影响续费率，建议调整" class="mt-sm" show-icon :closable="false">
            </el-alert>
          </div>
        </el-table-column>
        <el-table-column min-width="200" label="活动信息">
          <div slot-scope="scope" v-if="scope.row.activity_enable">
            <div>
              <span>{{ scope.row.activity_params.starttime |  parseTime('{y}/{m}/{d}') }}</span>
              <span>至</span>
              <span>{{ scope.row.activity_params.endtime |  parseTime('{y}/{m}/{d}') }}</span>
            </div>
            <div v-if="scope.row.activity_enable && scope.row.activity_params.title && scope.row.in_activity" class="text-primary">
              进行中
            </div>
            <div v-else-if="scope.row.activity_enable && scope.row.activity_params.title && time < scope.row.activity_params.starttime" class="text-danger">
              未开始
            </div>
            <div v-else style="color: #909399">
              已结束
            </div>
          </div>
        </el-table-column>
        <el-table-column min-width="100" label="设备数">
          <template slot-scope="scope">
            <span @click="toRms(scope.row)" style="color: rgba(48,49,51,1);font-size: 28px;cursor: pointer;">{{ scope.row.load_count }}</span>
          </template>
        </el-table-column>
        <el-table-column min-width="100" label="操作">
          <template slot-scope="scope">
            <div v-if="scope.row.is_default_platform_schemeid != 1" class="flex column">
              <el-button type="text" @click="toDetail(scope.row)" class="scheme_detail">方案详情</el-button>
              <el-button type="text" @click="toRms(scope.row)">方案设备</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

  </div>
</template>

<script>
import { schemeListApi, eiChargeDefault } from "@/api/ei/eiApi";

export default {
  name: "EiScheme",

  components: {
  },

  data() {
    return {
      type: null,
      loading: false,
      newScheme: false,
      query: {
        keyword: "",
        sort: 1,
      },
      schemes: [],
      multiSelection: [],
      time: parseInt(new Date().valueOf() / 1000),
      service: 0,
      rms_ei_share_ratio: 0,
      authorize: 0,
      sortOptions: [
        { value: 1, title: "最低价格" },
        { value: 2, title: "最高价格" },
        { value: 3, title: "最近创建" },
        { value: 4, title: "最早创建" },
      ],
      unitOptions: {
        year: "年",
      }
    };
  },

  computed: {
    aiot_version() {
      return this.$store.state.godStore.aiot_version;
    },

    superFastLogin() {
      return this.$store.state.userStore.superFastLogin;
    },

    servicechoose: function () {
      return "设置默认方案";
    },

    authorizechoose: function () {
      return "设置默认授权";
    }
  },
  watch: {

  },

  created() {
    this.fetchData();
  },
  mounted() {

  },

  methods: {
    fetchData() {
      this.loading = true;
      schemeListApi(this.query).then(res => {
        this.loading = false;
        if (res.errno === 0) {
          this.service = res.data.service;
          this.authorize = res.data.authorize;
          this.rms_ei_share_ratio = res.data.rms_ei_share_ratio;
          const ap_prices = res.data.ap_prices;
          if(res.data.list.length > 0) {
            res.data.list.map(item => {
              item.price = item.packages[0].total_selling_price;

              item.in_activity = item.activity_enable
                ? this.time > item.activity_params.starttime &&
                  this.time < item.activity_params.endtime
                : false;

              if((item.activity_enable && !item.activity_params.advanced_price_enable) || !item.activity_enable) {
                item.packages = item.packages.splice(0, 1)
              }
              if(item.packages.some(packageItem => packageItem.total_selling_price >= 200)) {
                item.show_tip = true
              } else {
                item.show_tip = false
              }
              return item
            })
          }

          this.schemes = res.data.list;
        } else {
          this.$message.error(res.message);
        }
      });
    },

    toNewScheme() {
      const godId = this.$store.state.godStore.godid
      if (!this.superFastLogin && this.aiot_version == 2 && godId !== 1) {
        this.$alert('合作版暂不支持该操作！', '提示', {
          type: 'warning'
        })
        return
      }
      this.$router.push('/ei/scheme/detail?schemeid=0');
    },

    pushData(data) {
      eiChargeDefault(data).then(res => { });
    },

    chooseService(id) {
      if (id === this.service) {
        this.service = 0;
        this.pushData({ service: this.service });
        return false;
      }
      this.service = id;
      this.pushData({ service: this.service });
    },

    toDetail(row) {
      if(row.is_default_platform_schemeid == 1) return
      const schemeid = row.schemeid
      this.$router.push('/ei/scheme/detail?schemeid=' + schemeid);
    },
    toRms(row) {
      const schemeid = row.schemeid
      this.$router.push('/ei/rms?schemeid=' + schemeid);
    },
  }
};
</script>

<style lang="scss" scoped>
.container_foot {
  font-size: 14px;
}

.number-price {
  line-height: 17px;
}
</style>

<style lang="scss" slot-scoped>
.ei-scheme {
  margin-bottom: -60px;

  .el-scrollbar {
    height: 460px;

    >.el-scrollbar__wrap {
      overflow-x: hidden;

      >.el-scrollbar__view {
        padding: 0 10px 0px 0;
      }
    }
  }

  .el-card-content {
    display: flex;
    flex-wrap: wrap;
    position: relative;

    .activity {
      position: relative;
      top: -10px;
      right: -10px;
      padding: 0 10px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      font-size: 14px;
      border-radius: 0px 10px 0px 10px;
      background: linear-gradient(to right, #ff7400, #ffae0c);
      &.activity_off {
        background: rgba(153,153,153,1);
      }
      &.unbegin {
        background: #e64340;
      }
    }
  }

  .el-table td {
    vertical-align: top;
  }

  .charge_card {
    width: 100%;
    padding: 10px;
    border-radius: 10px;
    position: relative;
    background-repeat: no-repeat;
    background-size: 100% 100%;

    .card_container {
      height: 100%;
      justify-content: space-between;

      .deadline {
        position: absolute;
        top: 75px;
        left: 15px;
        font-size: 12px;
      }

      .promotion {
        position: absolute;
        top: 100px;
        left: 15px;
        padding-right: 10px;
        font-size: 12px;
      }

      .default_item {
        position: absolute;
        font-size: 12px;
        padding: 0 10px;
        height: 20px;
        line-height: 20px;
        top: 40px;
        margin-right: 10px;
        border-radius: 10px;
      }

      .lock {
        position: absolute;
        bottom: 10px;
        left: 15px;
        font-size: 30px;
        color: white;
      }

      .first_item {
        background: #e64340;
      }

      .second_item {
        background: #409eff;
      }

      .third_item {
        display: none;
      }

      .fourth_item {
        display: none;
      }

      .container_foot {
        justify-content: flex-end;
        align-items: flex-end;

        .originalPrice {
          text-decoration: line-through;
          font-size: 14px;
          color: #333;
        }
      }
    }

    .container_close {
      position: absolute;
      top: 2px;
      right: 2px;

      .close_btn {
        visibility: hidden;
      }
    }
  }

  .charge_card:hover .close_btn {
    visibility: inherit;
  }

  .charge_card:hover {
    .default_item {
      transition: 0.5s;
    }

    .third_item {
      width: 95px;
      display: inherit;
      color: #e64340;
      border: 0.5px solid #e64340;
      background-color: rgba($color: #fff, $alpha: 0.9);
    }

    .fourth_item {
      width: 95px;
      display: inherit;
      color: #409eff;
      border: 0.5px solid #409eff;
      background-color: rgba($color: #fff, $alpha: 0.9);
    }
  }

  .scheme_item {
    width: 90px;
    height: 105px;
    border-radius: 5px;
    position: relative;
    font-size: 14px;
    background-color: rgba(255,255,255,1);
    border: 1px solid rgba(237,237,237,1);
    .discount {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 24px;
      line-height: 24px;
      background-color: rgba(7,193,96,0.4);
      color: rgba(7,193,96,1);
      font-size: 13px;
      text-align: center;
      border-radius: 0 0 5px 5px;
    }
  }
  .expected_item {
    width: 90px;
    height: 45px;
    border-radius: 5px;
    background-color: rgba(255,255,255,1);
    border: 1px solid rgba(237,237,237,1);
    font-size: 14px;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .el-button + .el-button {
    margin-left: 0px;
  }
  .el-button {
    text-align: left;
  }
  .scheme_detail {
    padding-top: 0px;
    padding-bottom: 5px;
  }
}

.line-through {
  text-decoration: line-through;
}

.h7 {
  font-size: 14px;
}
.price_tooltip.el-tooltip__popper {
  width: 320px;
}
</style>
